<ng-container *transloco="let t">
  @if (profile() || profileFailed()) {
    <button
      type="button"
      class="flex h-8 items-center gap-1 rounded-control px-2 text-text-secondary hover:bg-option-hover hover:text-text-primary max-lg:min-h-11 max-lg:min-w-11 max-lg:justify-center"
      [cdkMenuTriggerFor]="menu"
      [cdkMenuPosition]="menuPositions"
      [attr.aria-label]="t('nav.accountMenu')"
    >
      <span
        class="flex size-6 shrink-0 items-center justify-center rounded-full bg-text-primary text-caption font-semibold text-neutral-00"
        aria-hidden="true"
      >
        @if (profile()) {
          {{ initials() }}
        } @else {
          <fa-icon [icon]="accountIcon" />
        }
      </span>
      <fa-icon [icon]="chevronIcon" aria-hidden="true" />
    </button>

    <ng-template #menu>
      <div
        cdkMenu
        class="w-60 rounded-card text-body bg-surface py-1 shadow-menu"
        [attr.aria-label]="t('nav.accountMenu')"
      >
        @if (profile(); as userProfile) {
          <div class="px-3 py-2">
            <p class="text-body font-semibold">{{ userProfile.firstName }} {{ userProfile.lastName }}</p>
            <p class="text-caption text-text-secondary">{{ t(isOwner() ? 'nav.roleOwner' : 'nav.roleStaff') }}</p>
          </div>
          <div class="my-1 h-px bg-border-default" role="separator"></div>
        }
        @if (showGettingStarted()) {
          <a cdkMenuItem routerLink="/start" class="flex h-8 w-full items-center gap-2 px-3 text-left hover:bg-option-hover focus-visible:bg-option-hover max-lg:min-h-11">
            <fa-icon [icon]="gettingStartedIcon" aria-hidden="true" />
            <span class="flex-1">{{ t('nav.gettingStarted') }}</span>
            <app-badge color="info" [label]="t('nav.gettingStartedCount', { done: onboarding.doneOfTotal(), total: onboardingTotal })" />
          </a>
        }
        @if (size() === 'phone') {
          <button type="button" cdkMenuItem (cdkMenuItemTriggered)="openHelp()" class="flex h-8 w-full items-center gap-2 px-3 text-left hover:bg-option-hover focus-visible:bg-option-hover max-lg:min-h-11">
            <fa-icon [icon]="helpIcon" aria-hidden="true" />
            {{ t('nav.help') }}
          </button>
        }
        @if (size() === 'computer' && profile()) {
          <a cdkMenuItem routerLink="/settings/account" class="flex h-8 w-full items-center gap-2 px-3 text-left hover:bg-option-hover focus-visible:bg-option-hover max-lg:min-h-11">
            <fa-icon [icon]="accountIcon" aria-hidden="true" />
            {{ t('nav.account') }}
          </a>
        }
        <button type="button" cdkMenuItem (cdkMenuItemTriggered)="onLogout()" class="flex h-8 w-full items-center gap-2 px-3 text-left hover:bg-option-hover focus-visible:bg-option-hover max-lg:min-h-11">
          <fa-icon [icon]="logoutIcon" aria-hidden="true" />
          {{ t('nav.signOut') }}
        </button>
      </div>
    </ng-template>
  }
</ng-container>
